export const CUSTOM_REPORT_HEADER_AVERAGE_CHARACTER_WIDTH_PX = 8;
export const CUSTOM_REPORT_HEADER_HORIZONTAL_PADDING_PX = 32;
export const CUSTOM_REPORT_HEADER_HELP_ICON_WIDTH_PX = 24;
export const CUSTOM_REPORT_HEADER_SORT_ICON_WIDTH_PX = 20;

export const CUSTOM_REPORT_FILTERS_SEARCH_PARAM = "filters";
export const CUSTOM_REPORT_SORT_KEY_SEARCH_PARAM = "sortKey";
export const CUSTOM_REPORT_SORT_DIRECTION_SEARCH_PARAM = "sortDirection";
